import { Spin } from 'antd';
import { useStore } from '../store/store';
import { SECTION_LOADING_LOCK_ID } from './lockIds';

// Bannière affichée quand un co-éditeur injecte une section (verrou partagé
// reserved:section-loading). Les opérations structurelles locales sont gelées
// pendant ce temps (cf. structureLocks.sectionLoadingHolder).
export const SectionLoadingBanner = () => {
  const holder = useStore(({ boxLocks, user }) => {
    const lock = boxLocks[SECTION_LOADING_LOCK_ID];
    return lock && lock.id !== user?.id ? lock : null;
  });

  if (!holder) return null;

  return (
    <div
      style={{
        position: 'fixed',
        top: 64,
        left: '50%',
        transform: 'translateX(-50%)',
        zIndex: 2000,
        backgroundColor: holder.color ?? '#2196F3',
        color: '#fff',
        padding: '6px 16px',
        borderRadius: 4,
        boxShadow: '0 2px 8px rgba(0,0,0,0.25)',
        display: 'flex',
        alignItems: 'center',
        gap: 8,
      }}
    >
      <Spin size="small" />
      <span>{holder.name} charge une section…</span>
    </div>
  );
};

export default SectionLoadingBanner;
